
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useFormContext } from 'react-hook-form';

export const LearningStatusField: React.FC = () => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name="learning_status"
      render={({ field }) => (
        <FormItem>
          <FormLabel>สถานะการเรียนรู้</FormLabel>
          <FormControl>
            <Input placeholder="ระบุสถานะการเรียนรู้" {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
